// extracted by mini-css-extract-plugin
export default {"page":"Qi-z","landingBackground":"Ri-z","nonLandingBackground":"Si-z"};